import React from 'react';
import { ESTILO_EXPRES } from '../../constants/tramiteExpres';

// Riel de color a la izquierda de cada tarjeta de turno (.rec-item-riel). El trámite exprés va en
// azul aunque nazca como sobreturno: lo que importa de él es que fue exprés, no que no tuvo bloque.
function RielTurno({ turno, colorEstado }) {
    if (turno?.esTramiteExpres) {
        return <span className="rec-item-riel" style={{ background: ESTILO_EXPRES.riel }} />;
    }
    if (turno?.esSobreturno) {
        return <span className="rec-item-riel rec-item-riel--sobreturno" />;
    }
    return <span className="rec-item-riel" style={{ background: colorEstado }} />;
}

export default RielTurno;
